import React, { Component } from 'react'
import './RequestSelection.css'
import axios from 'axios'
import { Redirect } from 'react-router-dom'

import { CrfContext } from '../../CrfContext'
import redAssetLogo from '../../images/redassetmegawide.PNG'
import crfCardsAsset from './crfCardsAssetsNonPo.svg'
import crfCardsAssetPo from './crfCardsAssetsPo.svg'
import crfCardsAssetCashAdvance from './crfCardsAssetsCashAdvance.svg'
import crfCardsAssetLiquidation from './crfCardsAssetsLiquidation.svg'
import { Transition, animated } from 'react-spring/renderprops'

import SelectDepartmentModal from './SelectDepartmentModal'

import SideNav from '../sidenav/Sidenav.js'
import { Link } from 'react-router-dom'

export class RequestSelection extends Component {
  state = {
    redirect: false,
    redirectUrl: '/',

    card1: true,
    card2: false,
    card3: false,
    card4: false,

    departmentIsApproved: false,
    selectDepartment: false,
    waitForApproval: false,
    departmentInfo: '',
    userDepartments: [],
    hasApprovedDept: false,
    userRole: ''
  }

  componentDidMount () {
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        if (response.data.data.roles[0] !== 'Requestor') {
          this.setState({
            redirect: true,
            userRole: response.data.data.roles[0]
          })
        }
        for (let i = 0; i < response.data.data.departments.length; i++) {
          console.log(response.data.data.departments[i].isApproved)
          if (response.data.data.departments[i].isApproved === true) {
            this.setState({
              hasApprovedDept: true
            })
          }
        }
        const data = response.data.data
        this.setState({
          userDepartments: data.departments
        })
        console.log(response.data.data.departments)
        this.setState({
          departmentIsApproved: data.department.isApproved,
          departmentInfo: data.departments
        })
        console.log(data)
      })
      .catch(error => {
        console.log(error.response)
      })
  }

  handleShowSelectDepartmentModal = () => {
    console.log('Hello')
    this.setState({
      selectDepartment: true
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  handleShowWaitForApprovalModal = () => {
    this.setState({
      waitForApproval: true
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  closeReturnModal = e => {
    e.preventDefault()
    document.getElementById('modalBody').style.display = 'none'
  }

  render () {
    if (this.state.redirect === true) {
      return <Redirect to={this.state.redirectUrl} />
    }

    console.log(this.state)

    // TRANSITION OF CARDS

    if (this.state.card1) {
      if (document.getElementById('card1')) {
        setTimeout(() => {
          document.getElementById('card1').style.opacity = '1'
        }, 100)
      }
      if (document.getElementById('card2')) {
        setTimeout(() => {
          document.getElementById('card2').style.opacity = '1'
        }, 200)
      }
      if (document.getElementById('card4')) {
        setTimeout(() => {
          document.getElementById('card4').style.opacity = '1'
        }, 300)
      }
      if (document.getElementById('card3')) {
        setTimeout(() => {
          document.getElementById('card3').style.opacity = '1'
        }, 400)
      }
    }

    return (
      <CrfContext.Consumer>
        {context => (
          <div id='mainPage'>
            <SelectDepartmentModal
              closeReturnModal={this.closeReturnModal}
              selectDepartment={this.state.selectDepartment}
              waitForApproval={this.state.waitForApproval}
              handleShowSelectDepartmentModal={
                this.handleShowSelectDepartmentModal
              }
            />

            <div id='sidePanel'>
              <SideNav
              //   testState = {context.state.testState}
              //   toggleBtn1List = {context.toggleBtn1List}
              //   toggleBtn2List = {context.toggleBtn2List}
              //   btn1List = {context.state.btn1List}
              //   btn2List = {context.state.btn2List}
              //   userRole = {context.state.userRole}
              />
            </div>
            <div id='mainPanel'>
              <div className='requestSelectionPanel'>
                <div className='requestSelectionHeader'>
                  {/* <div className="createRequestHeader">
                        <div className="createRequestHeaderContent">
                        <h1>Create Request</h1>
                            <div className="subHeader">
                                <h3>Select Request Type</h3>
                            </div>
                        </div>
                    </div> */}
                  <h1>Create Request</h1>
                  <h3>Select Request Type</h3>
                </div>
                <div className='requestSelectionContent'>
                  {/* CARD 1 */}
                  {/* ============= PO CARD =============================================================================================== */}
                  {this.state.userDepartments.length === 0 ? (
                    <div className='cardContent' id='card1'>
                      <div
                        onClick={this.handleShowSelectDepartmentModal}
                        className='cardBody'
                      >
                        <div className='cardHead'>
                          <img
                            className='cardAssetPo'
                            src={crfCardsAssetPo}
                            alt=''
                          />
                          <svg width='100%' height='100%'>
                            <polygon
                              fill='accent'
                              points='0,50 0,0 450,0 150,200'
                            />
                          </svg>
                        </div>
                        <div className='cardFooter'>
                          <p>PO ITEMS</p>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {this.state.userDepartments.length !== 0 &&
                  !this.state.hasApprovedDept ? (
                    <div className='cardContent' id='card1'>
                      <div
                        onClick={this.handleShowWaitForApprovalModal}
                        className='cardBody'
                      >
                        <div className='cardHead'>
                          <img
                            className='cardAssetPo'
                            src={crfCardsAssetPo}
                            alt=''
                          />
                          <svg width='100%' height='100%'>
                            <polygon
                              fill='accent'
                              points='0,50 0,0 450,0 150,200'
                            />
                          </svg>
                        </div>
                        <div className='cardFooter'>
                          <p>PO ITEMS</p>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {this.state.hasApprovedDept === true &&
                  !context.state.isProject ? (
                    <div className='cardContent' id='card1'>
                      <Link to='/PoItems'>
                        <div className='cardBody'>
                          <div className='cardHead'>
                            <img
                              className='cardAssetPo'
                              src={crfCardsAssetPo}
                              alt=''
                            />
                            <svg width='100%' height='100%'>
                              <polygon
                                fill='accent'
                                points='0,50 0,0 450,0 150,200'
                              />
                            </svg>
                          </div>
                          <div className='cardFooter'>
                            <p>PO ITEMS</p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : (
                    <div className='cardContent' id='card1'>
                      {/* <Link to='/RequestSelection'> */}
                      <div className='cardBody'>
                        <div className='noCashAdvanceMessage'>
                          <p>For Head Office only</p>
                        </div>
                        <div className='cardHead'>
                          <img
                            className='cardAssetLiquidation'
                            src={crfCardsAssetLiquidation}
                            alt=''
                          />
                          <svg width='100%' height='100%'>
                            <polygon
                              fill='accent'
                              points='0,50 0,0 450,0 150,200'
                            />
                          </svg>
                        </div>
                        <div className='cardFooter'>
                          <p>PO Items</p>
                        </div>
                      </div>
                      {/* </Link> */}
                    </div>
                  )}

                  {/* ============= END PO CARD ========================================================================================= */}
                  {/* END CARD 1 */}

                  {/* CARD 2 */}
                  {/* ============ NON PO CARD ==============================================================================          */}
                  {this.state.userDepartments.length === 0 ? (
                    <div className='cardContent' id='card2'>
                      <div
                        onClick={this.handleShowSelectDepartmentModal}
                        className='cardBody'
                      >
                        <div className='cardHead'>
                          <img
                            className='cardAssetNonPo'
                            src={crfCardsAsset}
                            alt=''
                          />
                          <svg width='100%' height='100%'>
                            <polygon
                              fill='accent'
                              points='0,50 0,0 450,0 150,200'
                            />
                          </svg>
                        </div>
                        <div className='cardFooter'>
                          <p>NON PO ITEMS</p>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {this.state.userDepartments.length !== 0 &&
                  !this.state.hasApprovedDept ? (
                    <div className='cardContent' id='card2'>
                      <div
                        onClick={this.handleShowWaitForApprovalModal}
                        className='cardBody'
                      >
                        <div className='cardHead'>
                          <img
                            className='cardAssetNonPo'
                            src={crfCardsAsset}
                            alt=''
                          />
                          <svg width='100%' height='100%'>
                            <polygon
                              fill='accent'
                              points='0,50 0,0 450,0 150,200'
                            />
                          </svg>
                        </div>
                        <div className='cardFooter'>
                          <p>NON PO ITEMS</p>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {this.state.hasApprovedDept === true ? (
                    <div className='cardContent' id='card2'>
                      <Link to='/NonPoItems'>
                        <div className='cardBody'>
                          <div className='cardHead'>
                            <img
                              className='cardAssetNonPo'
                              src={crfCardsAsset}
                              alt=''
                            />
                            <svg width='100%' height='100%'>
                              <polygon
                                fill='accent'
                                points='0,50 0,0 450,0 150,200'
                              />
                            </svg>
                          </div>
                          <div className='cardFooter'>
                            <p>NON PO ITEMS</p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : null}
                </div>
                {/* END CARD 2 */}
                {/* ============END of NON PO CARD ========================================================================= */}
                {/* =============== CASH ADVANCE CARD =========================================================================== */}

                {/* === */}
                <div className='requestSelectionContent'>
                  {this.state.userDepartments.length === 0 ? (
                    <div className='cardContent' id='card3'>
                      <div
                        onClick={this.handleShowSelectDepartmentModal}
                        className='cardBody'
                      >
                        <div className='cardHead'>
                          <img
                            className='cardAssetCashAdvance'
                            src={crfCardsAssetCashAdvance}
                            alt=''
                          />
                          <svg width='100%' height='100%'>
                            <polygon
                              fill='accent'
                              points='0,50 0,0 450,0 150,200'
                            />
                          </svg>
                        </div>
                        <div className='cardFooter'>
                          <p>CASH ADVANCE</p>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {this.state.userDepartments.length !== 0 &&
                  !this.state.hasApprovedDept ? (
                    <div className='cardContent' id='card3'>
                      <div
                        onClick={this.handleShowWaitForApprovalModal}
                        className='cardBody'
                      >
                        <div className='cardHead'>
                          <img
                            className='cardAssetCashAdvance'
                            src={crfCardsAssetCashAdvance}
                            alt=''
                          />
                          <svg width='100%' height='100%'>
                            <polygon
                              fill='accent'
                              points='0,50 0,0 450,0 150,200'
                            />
                          </svg>
                        </div>
                        <div className='cardFooter'>
                          <p>CASH ADVANCE</p>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {this.state.hasApprovedDept === true ? (
                    <div className='cardContent' id='card3'>
                      {/* <Link to='/CashAdvance'> */}
                      <div className='cardBody'>
                        <div className='noCashAdvanceMessage'>
                          <p>Under Construction.</p>
                        </div>
                        <div className='cardHead'>
                          <img
                            className='cardAssetCashAdvance'
                            src={crfCardsAssetCashAdvance}
                            alt=''
                          />
                          <svg width='100%' height='100%'>
                            <polygon
                              fill='accent'
                              points='0,50 0,0 450,0 150,200'
                            />
                          </svg>
                        </div>
                        <div className='cardFooter'>
                          <p>CASH ADVANCE</p>
                        </div>
                      </div>
                      {/* </Link> */}
                    </div>
                  ) : null}

                  {/* =================== END CASH ADVANCE CARD ============================================================================ */}

                  <div className='cardContent' id='card4'>
                    {/* <Link to='/RequestSelection'> */}
                    <div className='cardBody'>
                      <div className='noCashAdvanceMessage'>
                        <p>Under Construction.</p>
                      </div>
                      <div className='cardHead'>
                        <img
                          className='cardAssetLiquidation'
                          src={crfCardsAssetLiquidation}
                          alt=''
                        />
                        <svg width='100%' height='100%'>
                          <polygon
                            fill='accent'
                            points='0,50 0,0 450,0 150,200'
                          />
                        </svg>
                      </div>
                      <div className='cardFooter'>
                        <p>LIQUIDATION</p>
                      </div>
                    </div>
                    {/* </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </CrfContext.Consumer>
    )
  }
}

export default RequestSelection
